import { Link } from 'react-router-dom';
import { mangas } from '@/mocks/manga';
import MangaCard from '@/components/feature/MangaCard';

export default function FeaturedSection() {
  const featured = mangas.filter((m) => m.isRecommend);

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16" aria-label="热门连载推荐">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">
            Editor's Pick
          </span>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">热门连载推荐</h2>
        </div>
        <Link
          to="/category"
          className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
        >
          查看全部漫画
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-5">
        {featured.map((manga) => (
          <MangaCard key={manga.id} manga={manga} />
        ))}
      </div>
    </section>
  );
}